

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const LocationAdvantage = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const BASE_URL = "https://100billionoms.com"; // Replace with your backend base URL

    useEffect(() => {
        fetchAmenities();
    }, []);

    // Fetch amenities from backend
    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/location/all/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching location:', error);
        }
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    // const handleAddAmenities = async () => {
    //     if (!inputValue.trim()) {
    //         toast.warning('Please enter location advantage');
    //         return;
    //     }

    //     const newAmenities = inputValue.split(',').map((amenity) => amenity.trim()).filter((amenity) => amenity !== '');

    //     const dataToUpdate = { name: newAmenities[0], status: 'active', user_id: isLoggedIn.user_id };
    //     try {
    //         const response = await axios.post(`${BASE_URL}/location/igothousifyu`, dataToUpdate);
    //         if (response.status === 200) {
    //             toast.success('New Location Advantage Added');
    //             fetchAmenities();
    //             setInputValue('');
    //             setIsModalOpen(false);
    //             setSelectedFile(null);
    //         }
    //     } catch (error) {
    //         toast.error(error);
    //         console.error('Error adding location:', error);
    //     }
    // };

    const handleAddAmenities = async () => {
        if (!inputValue.trim()) {
            toast.warning('Please enter location advantages');
            return;
        }

        const newAdvantages = inputValue.split(',').map((item) => item.trim()).filter((item) => item !== '');

        try {
            for (const adv of newAdvantages) {
                const dataToUpdate = {
                    name: adv,
                    status: 'active',
                    user_id: isLoggedIn.user_id
                };

                const response = await axios.post(`${BASE_URL}/location/igothousifyu`, dataToUpdate);
                if (response.status === 200) {
                    
                }
            }

            toast.success('All Location Advantages Added');
            fetchAmenities(); // Refresh list
            setInputValue('');
            setIsModalOpen(false);
            setSelectedFile(null);
        } catch (error) {
            toast.error('Error adding one or more items');
            console.error('Error:', error);
        }
    };

    const handleEditChange = (event) => {
        setEditValue(event.target.value);
    };

    const handleEdit = (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        setEditIndex(absoluteIndex);
        setEditValue(amenities[absoluteIndex].name);
    };

    const handleSaveEdit = async (index) => {
        const amenity = amenities[index];
        const dataToUpdate = { name: editValue, status: amenity.status };

        try {
            const response = await axios.put(`${BASE_URL}/location/change/${amenity.id}`, dataToUpdate);
            if (response.status === 200) {
                toast.success('Location Advantage updated');
                fetchAmenities();
                setEditIndex(null);
                setEditValue('');
            }
        } catch (error) {
            toast.error(error);
            console.error('Error updating location:', error.response.data || error.message);
        }
    };


    const handleDelete = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        try {
            const response = await axios.delete(`${BASE_URL}/location/${amenity.id}`);
            if (response.status === 200) {
                toast.success('Location Deleted');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error deleting location:', error);
        }
    };

    const handleToggleStatus = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        const updatedStatus = amenity.status === 'active' ? 'inactive' : 'active';

        try {
            const response = await axios.put(`${BASE_URL}/location/change/${amenity.id}`, { status: updatedStatus });
            if (response.status === 200) {
                toast.success('Location adavantage Status Updated');
                fetchAmenities();
            }
        } catch (error) {
            toast.error(error);
            console.error('Error toggling status:', error);
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = amenities.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(amenities.length / itemsPerPage);

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Location Advantage</h1>
                    <button className="oms-add-btn" onClick={openModal}>
                        Add Advantage
                    </button>
                </div>
                <div className="amenities-container">
                    {/* <div className="amenities-header">
                <h1>Location Advantage</h1>
                <div className="add-btn">
                    <button className="add-btn" onClick={openModal}>
                        Add Advantage
                    </button>
                </div>
            </div> */}

                    {/* Modal for adding amenities */}
                    {isModalOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <h3>Add Location Advantage</h3>
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    placeholder="Enter advantages"
                                />
                                {/* <input type="file" onChange={handleFileChange} /> */}
                                <div className="modal-actions">
                                    <button onClick={handleAddAmenities}>Add</button>
                                    <button onClick={closeModal}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Amenities Table */}
                    <div className="amenities-table">
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Advantage</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems && currentItems.length > 0 ? (
                                    currentItems.map((amenity, index) => {
                                        const absoluteIndex = indexOfFirstItem + index;
                                        return <tr key={absoluteIndex}>
                                            <td>
                                                {editIndex === absoluteIndex ? (
                                                    <input
                                                        type="text"
                                                        value={editValue}
                                                        onChange={handleEditChange}
                                                    />
                                                ) : (
                                                    amenity.name
                                                )}
                                            </td>
                                            <td>
                                                <span className={amenity.status}>
                                                    {amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}
                                                </span>
                                            </td>
                                            <td>
                                                {editIndex === absoluteIndex ? (
                                                    <button onClick={() => handleSaveEdit(index)}>Save</button>
                                                ) : (
                                                    <>
                                                        <button onClick={() => handleToggleStatus(index)}>
                                                            <i className={`fa ${amenity.status === 'active' ? 'fa-toggle-on' : 'fa-toggle-off'}`} />
                                                        </button>
                                                        <button onClick={() => handleEdit(index)}>
                                                            <i className="fa fa-edit" />
                                                        </button>
                                                        <button onClick={() => handleDelete(index)}>
                                                            <i className="fa fa-trash" />
                                                        </button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="3">No data available</td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                        <div className="pagination-container">
                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                ◀ Prev
                            </button>

                            <span className="pagination-current">Page {currentPage} of {totalPages}</span>

                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Next ▶
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LocationAdvantage;


